import {App, Button, Popover, Table as AntTable} from "antd";
import {ReactNode, useState} from 'react';
import {TableProps} from "antd/es/table/InternalTable";
import {configConfirmModal, HorizonDots} from "@/theme";

export const TableRoot = ({...rest}: TableProps<any>) => {
    return (
        <>
            <AntTable
                tableLayout="fixed"
                scroll={{x: '100%'}}
                pagination={false}
                {...rest}
            />
        </>
    );
}

type ActionOptionsType = {
    content: ReactNode
}
const ActionOptions = ({content,...rest}: ActionOptionsType) =>{
    const [open, setOpen] = useState(false)

    return(
        <Popover
            onOpenChange={()=>{
                setOpen(!open)
            }}
            rootClassName={'table_options_button'}
            content={(
                <div
                    onClick={(e)=>{
                        e.preventDefault()
                        setOpen(!open)
                    }}
                >
                    {content}
                </div>
            )}
            trigger="click"
            placement={'bottomRight'}
            arrow={false}
            open={open}
            {...rest}
        >
            <Button
                type="text"
                icon={<HorizonDots />}
                onClick={()=>{
                    setOpen(!open)
                }}
            />
        </Popover>
    )
}


type ActionButtonType = {
    type?: "default" | "danger",
    children: ReactNode
    onClick: () => void;
    confirm?: any;
}
const ActionButton = ({type = 'default', children, onClick, confirm}: ActionButtonType) =>{
    const {modal} = App.useApp();

    return(
        <div
            className={`button ${type}`}
            onClick={async () => {
                if (confirm){
                    // @ts-ignore
                    modal.confirm(configConfirmModal({
                        ...confirm,
                        onOk: () =>{
                            if (onClick){
                                onClick()
                            }
                        }
                    }))
                }else {
                    if (onClick){
                        onClick()
                    }
                }
            }}
        >
            {children}
        </div>
    )
}

export const Table = TableRoot as typeof TableRoot & {
    ActionOptions: typeof ActionOptions;
    ActionButton: typeof ActionButton;
};

Table.ActionOptions = ActionOptions
Table.ActionButton = ActionButton